import { render, staticRenderFns } from "./OtpAuthSettingIframe.vue?vue&type=template&id=1a0d8564&"
import script from "./OtpAuthSettingIframe.vue?vue&type=script&lang=ts&"
export * from "./OtpAuthSettingIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports